import eventBus from './EventBus';

class LayerManager {
  constructor(canvasManager) {
    this.canvasManager = canvasManager;
  }

  getLayers() {
    if (!this.canvasManager.canvas) return [];
    const objects = this.canvasManager.canvas.getObjects();
    return objects
      .filter((obj) => !obj.isGrid && !obj.isBleed && !obj.isHem && !obj.isHohlsaum && !obj.isGrommet && !obj.isSnapLine && !obj.isGuide)
      .map((obj, index) => ({
        id: obj.__uid || (obj.__uid = this._generateId()),
        name: obj.customName || this._getDisplayName(obj),
        type: obj.type,
        visible: obj.visible !== false,
        locked: !!obj.isLocked,
        index: index,
        object: obj,
      }))
      .reverse();
  }

  setVisibility(id, visible) {
    const obj = this._findById(id);
    if (!obj || !this.canvasManager.canvas) return;
    obj.set('visible', visible);
    this.canvasManager.canvas.renderAll();
    eventBus.emit('layers:changed');
    eventBus.emit('canvas:changed');
  }

  setLocked(id, locked) {
    const obj = this._findById(id);
    if (!obj || !this.canvasManager.canvas) return;
    obj.set({
      lockMovementX: locked,
      lockMovementY: locked,
      lockRotation: locked,
      lockScalingX: locked,
      lockScalingY: locked,
      hasControls: !locked,
      isLocked: locked,
    });
    this.canvasManager.canvas.renderAll();
    eventBus.emit('layers:changed');
    eventBus.emit('canvas:changed');
  }

  reorder(id, newIndex) {
    const obj = this._findById(id);
    if (!obj || !this.canvasManager.canvas) return;
    this.canvasManager.canvas.moveTo(obj, newIndex);
    this.canvasManager.canvas.renderAll();
    eventBus.emit('layers:changed');
    eventBus.emit('canvas:changed');
  }

  renameLayer(id, name) {
    const obj = this._findById(id);
    if (!obj) return;
    obj.customName = name;
    eventBus.emit('layers:changed');
  }

  selectLayer(id) {
    const obj = this._findById(id);
    if (!obj || !this.canvasManager.canvas) return;
    this.canvasManager.canvas.setActiveObject(obj);
    this.canvasManager.canvas.renderAll();
  }

  deleteLayer(id) {
    const obj = this._findById(id);
    if (!obj || !this.canvasManager.canvas) return;
    this.canvasManager.canvas.remove(obj);
    this.canvasManager.canvas.renderAll();
    eventBus.emit('layers:changed');
    eventBus.emit('canvas:changed');
  }

  _findById(id) {
    if (!this.canvasManager.canvas) return null;
    return this.canvasManager.canvas.getObjects().find((obj) => obj.__uid === id);
  }

  _generateId() {
    return 'layer_' + Math.random().toString(36).substr(2, 9);
  }

  _getDisplayName(obj) {
    // For text objects, show first few words of actual text
    if (['i-text', 'text', 'textbox'].includes(obj.type) && obj.text) {
      const words = obj.text.trim().split(/\s+/).slice(0, 3).join(' ');
      const truncated = words.length > 25 ? words.substring(0, 22) + '...' : words;
      return truncated || 'Text';
    }
    return this._getTypeName(obj.type);
  }

  _getTypeName(type) {
    const names = {
      rect: 'Rechteck',
      circle: 'Kreis',
      line: 'Linie',
      polygon: 'Polygon',
      'i-text': 'Text',
      text: 'Text',
      textbox: 'Textbox',
      image: 'Bild',
      group: 'Gruppe',
      path: 'Pfad',
    };
    return names[type] || 'Objekt';
  }
}

export default LayerManager;
